// T419 — the one thing that survived SourceHealthPanel.
//
// That component had two variants: a one-line summary for the dashboard and
// a full table — a near-copy of the entire /sources page, roughly 130 lines
// of collapsible table, mobile cards, auto-expand and its own scan trigger.
// The full variant was rendered nowhere; its only caller was its own test.
//
// Source health had four surfaces: the failure banner (dashboard), a
// "Sources active" stat card (dashboard), this summary (dashboard), and the
// page that actually lets him do something about it. Answering "is anything
// broken?" meant reading three of them and believing whichever he saw first.
// Now the banner says it when it is true and links to the one place that can
// act on it, and this badge is shared by the banner and the page.

const TONE = {
  error: 'border-red-800 text-red-400 bg-red-950/30',
  'low-yield': 'border-amber-700 text-amber-300 bg-amber-950/30',
  silent: 'border-slate-700 text-slate-400 bg-slate-900/50',
  ok: 'border-emerald-800 text-emerald-300 bg-emerald-950/20',
};
const LABEL = { error: 'erroring', 'low-yield': 'low yield', silent: 'silent', ok: 'ok' };

export function Badge({ status, count }) {
  return (
    <span className={'rounded-full border px-2 py-0.5 text-[10px] font-medium ' + (TONE[status] ?? TONE.ok)}>
      {count != null ? `${count} ` : ''}
      {LABEL[status] ?? status}
    </span>
  );
}

export default Badge;
